import {Ic, ISwitchingFrqParam} from "./common";
import {Utils} from "../common/utils";

/**
 * Created by claudio iozzia on 26/06/2017.
 */

export class IC_fsw implements ISwitchingFrqParam {
  private static DEF_TON_MIN: number = 10E-9;

  private ic_fsw: ISwitchingFrqParam;

  constructor(private ic: Ic) {
    this.ic_fsw = ic.fsw;
  }

  public get fosc_min(): number {
    return this.ic_fsw.fosc_min;
  }

  public get fosc_max(): number {
    return this.ic_fsw.fosc_max;
  }

  public get fosc_def(): number {
    return this.ic_fsw.fosc_def;
  }

  public get fsync_min(): number {
    return this.ic_fsw.fsync_min;
  }

  public get fsync_max(): number {
    return this.ic_fsw.fsync_max;
  }

  public get fsync_def(): number {
    return this.ic_fsw.fsync_def;
  }

  public get has_internal_osc(): boolean {
    return !isNaN(this.ic_fsw.fosc_min) || !isNaN(this.ic_fsw.fosc_max);
  }

  public get programmable_fosc(): boolean {
    return /*has_internal_osc &&*/ this.ic_fsw.fosc_min !== this.ic_fsw.fosc_max;
  }

  public get synchronizable(): boolean {
    return !isNaN(this.ic_fsw.fsync_min) && !isNaN(this.ic_fsw.fsync_max);
  }

  public get fixed(): boolean {
    return !this.selectable;
  }

  public get selectable(): boolean {
    return this.min !== this.max;
  }

  public max_fton(duty: number): number {
    return duty / this.ton_min;
  }

  public get ton_min(): number {
    return Utils.getFieldValue(this.ic_fsw, "ton_min", IC_fsw.DEF_TON_MIN);
  }

  public get dMax(): number {
    return Utils.getFieldValue(this.ic_fsw, "dMax", 100) / 100;
  }

  public get min(): number {
    if (!this.has_internal_osc)
      return this.ic_fsw.fsync_min;

    if (!this.synchronizable)
      return this.ic_fsw.fosc_min;

    return Math.min(this.ic_fsw.fosc_min, this.ic_fsw.fsync_min);
  }

  public get max(): number {
    if (!this.has_internal_osc)
      return this.ic_fsw.fsync_max;

    if (!this.synchronizable)
      return this.ic_fsw.fosc_max;

    return Math.max(this.ic_fsw.fosc_max, this.ic_fsw.fsync_max);
  }

  public get def(): number {
    return this.ic_fsw.fosc_def;
  }

  public get has_def(): boolean {
    return !isNaN(this.def);
  }

}
